// Real card-number prefix ranges networks use to identify a brand  these
// aren't linked to any real card, they only satisfy the Luhn checksum used
// to validate a card number's format.
const BRANDS = {
  visa: { label: 'Visa', prefix: () => '4', length: 16 },
  mastercard: {
    label: 'Mastercard',
    prefix: () => `5${1 + Math.floor(Math.random() * 4)}`,
    length: 16,
  },
  amex: { label: 'American Express', prefix: () => '3', length: 15 },
}

const luhnCheckDigit = (digits) => {
  let sum = 0
  let shouldDouble = true
  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = digits[i]
    if (shouldDouble) {
      digit *= 2
      if (digit > 9) digit -= 9
    }
    sum += digit
    shouldDouble = !shouldDouble
  }
  return (10 - (sum % 10)) % 10
}

export const generateTestCard = (brandKey) => {
  const brand = BRANDS[brandKey] || BRANDS.visa
  const prefix = brand.prefix()
  const bodyLength = brand.length - prefix.length - 1
  let digits = prefix
  for (let i = 0; i < bodyLength; i++) {
    digits += Math.floor(Math.random() * 10)
  }
  const numericDigits = digits.split('').map(Number)
  const check = luhnCheckDigit([...numericDigits, 0])
  const fullNumber = digits + check

  // Amex is traditionally grouped 4-6-5; other brands here are 4-4-4-4.
  const groups =
    brand.length === 15
      ? [fullNumber.slice(0, 4), fullNumber.slice(4, 10), fullNumber.slice(10)]
      : fullNumber.match(/.{1,4}/g)

  return {
    brand: brand.label,
    number: fullNumber,
    formatted: groups.join(' '),
    expiry: `${String(1 + Math.floor(Math.random() * 12)).padStart(2, '0')}/${28 + Math.floor(Math.random() * 6)}`,
    cvv: brand.length === 15
      ? String(1000 + Math.floor(Math.random() * 9000))
      : String(100 + Math.floor(Math.random() * 900)),
  }
}

export const CARD_BRANDS = Object.entries(BRANDS).map(([key, b]) => ({
  key,
  label: b.label,
}))
